"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Vue Element Admin',
      logo: '',
      logoSmall: ''
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    setUrl: function setUrl(url) {
      return (0, _index.preFixxUrl)(url);
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _infoMessage.getProcedureParamConfig)().then(function (res) {
        var nowIndex = res.findIndex(function (item) {
          return item.key == 'admin_website_log';
        });
        _this.logoSmall = res[nowIndex].value;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};
exports.default = _default;